if (!customElements.get('stock-alert')) {
  customElements.define(
    'stock-alert',
    class StockAlert extends HTMLElement {
      connectedCallback() {
        const sku = this.dataset.sku;
        const endpoint = this.dataset.endpoint;
        const threshold = parseInt(this.dataset.threshold, 10) || 10;
        if (!sku || !endpoint) return;

        fetch(endpoint + sku, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'x-shopify-shop-domain': 'homecenter2.myshopify.com',
          },
        })
          .then((response) => {
            if (!response.ok) throw new Error('Network response failed: ' + response.statusText);
            return response.json();
          })
          .then((data) => {
            const branches = data.branches || [];
            const total = branches.reduce((sum, branch) => sum + (parseInt(branch.inventory_status, 10) || 0), 0);
            if (total <= 0 || total > threshold) return;

            const heading = this.querySelector('[data-stock-alert-heading]');
            heading.textContent = heading.dataset.text.replace('[n]', total);
            this.querySelector('[data-stock-alert-count]').textContent = total;

            const ringScale = 0.78 + (0.22 * total) / threshold;
            this.querySelector('.stock-alert__badge').style.setProperty('--ring-scale', ringScale.toFixed(3));

            this.hidden = false;
          })
          .catch((error) => {
            console.error('stock-alert: ' + error);
          });
      }
    }
  );
}
